import type { PageTour } from '../types';

export const analyticsTour: PageTour = {
  id: 'analytics',
  label: 'Analytics Tour',
  steps: [
    {
      target: '[data-tour="analytics-header"]',
      title: 'Analytics Hub',
      content: 'Your central hub for data and insights. Explore team metrics, project health, and organizational trends.',
    },
    {
      target: '[data-tour="analytics-categories"]',
      title: 'Report Categories',
      content: 'Analytics are organized by category — team, organization, and project. Choose a category to get started.',
    },
    {
      target: '[data-tour="analytics-cards"]',
      title: 'Available Reports',
      content: 'Each card is a report you can dive into. Click any card to see detailed charts and data.',
    },
  ],
};
